export const $getImageUrl = (dir) => {
  return new URL(`/src/${dir}`, import.meta.url).href;
};

export default {
  install(app) {
    app.prototype.$getImageUrl = $getImageUrl;
  },
};
